import React, { useState, useEffect } from "react";
import {Box, Button, List, ListItem, CircularProgress, Checkbox, InputLabel, Divider} from "@mui/material";
import ListDivider from '@mui/joy/ListDivider';
import Image from "mui-image";
import CloseIcon from '@mui/icons-material/Close';
import {useSelector, useDispatch, connect} from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

import { useWindowWidth } from "../../../../utils/browser";
import {
    setMessageSnackbarStateState,
    setTikTokPlatformDetailsState,
    setTopUpDetailsState
} from "../../../../redux/slices/common";
import styles from './TikTokPlatformDetails.module.scss';
import Typography from "@mui/material/Typography";
import {setMessage} from "../../../../redux/slices/message";
import ExlService from "../../../../services/api/excelate.service";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import TikTokService from "../../../../services/api/tiktok.service";


const TikTokPlatformDetails = ({ isTikTokCollapsed , handleTikTokCollapsed, handleTikTokChange}) => {

    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [selectedAccount, setSelectedAccount] = useState(0);
    const { selectedCountry } = useSelector((state) => state.auth);
    const { user } = useSelector((state) => state.auth.auth);
    const { currentTheme } = useSelector((state) => state.theme);
    const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));
    const { tikTokPlatformDetailsState } = useSelector((state) => state.common);
    const [activeStep, setActiveStep] = useState(0);
    const maxSteps = 2;
    const [checked, setChecked] = useState(false);
    const [loading, setLoading] = useState(true); // New loading state
    const [isShow, setIsShow] = useState(false);
    const [tikTokAdvAccount, setTikTokAdvAccount] = useState([]);

    useEffect(() => {
        let mounted = true;
        if (mounted) {

            const queryParams = [
                `userId=${user.id}`
            ];


            TikTokService.getAllAdv(queryParams.join('&')).then(data => {
                //console.log("API List response: ", data);

                if (data.results && data.results.length > 0) {

                    setTikTokAdvAccount(data.results);
                    //const selectedBusiness = data.results.find(business => business.isSelected);
                    setSelectedAccount(data.results[0].id.toString());
                    setLoading(false);
                }
            }).catch(error => {
                console.error("Error calling API: ", error);
                setLoading(false);
                handleClose();
            });
        }

        return () => {
            mounted = false;

        };
    }, []);

    const handleOpen = () => {

        dispatch(setTikTokPlatformDetailsState(true));
    };

    const handleClose = () => {

        setActiveStep(0);
        dispatch(setTikTokPlatformDetailsState(false));
        handleTikTokCollapsed();
    };

    const radioColor = currentTheme === 'light' ? '#3955BF' : '#3955BF';


    const handleSubmit = () => {


        const queryParams = [
            `userId=${user.id}`,
            `advAccountId=${selectedAccount}`,
            `isChecked=${checked}`
        ];

        TikTokService.changeAdvAccount(queryParams.join('&')).then(data => {

            setTikTokAdvAccount(data.results);
            dispatch(setMessage({
                type: "success",
                title: "Tiktok Advertising Account selected successfully",
            }));
            dispatch(setMessageSnackbarStateState(true));

        }).catch(error => {
            setIsShow(true);
            dispatch(setMessage({
                type: "error",
                title: error?.response?.data?.message,
            }));
            dispatch(setMessageSnackbarStateState(true));
        });

        handleTikTokCollapsed();
        handleTikTokChange();
    }

    const handleRadioChange = (event) => {

        setSelectedAccount(event.target.value);
    };



    return (<>
            <SwipeableDrawer
                anchor={"right"}
                open={tikTokPlatformDetailsState}
                onClose={handleClose}
                onOpen={handleOpen}
                PaperProps={{
                    sx: {
                        width: "30%",
                        overflow: "visible",
                        display: "flex", // Make the drawer content a flexbox
                        flexDirection: "column", // Arrange children in a column
                        borderLeft: "1px solid #212330",
                    },
                }}
                sx={{
                    backdropFilter: "blur(2px)",
                }}
            >
                {isTikTokCollapsed && (
                    <Button
                        className={`${styles.LogoutButton ?? ""}`}
                        onClick={handleClose}
                        sx={{
                            backgroundColor: currentTheme === "dark" ? "#ffffff" : "#202020",
                            color: "red",
                            width: 55,
                            height: 55,
                            minWidth: "initial",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "50%",
                            position: "absolute",
                            left: "-28px",
                            top: 40,
                            zIndex: 2000,
                            "&:hover": { background: "white !important" },
                        }}
                    >
                        <CloseIcon sx={{ width: 25, height: 25 }} />
                    </Button>
                )}
                <Box style={{ paddingTop: "50px", paddingLeft: "50px", paddingRight: "30px", flex: 1, overflowY: "auto" }}>
                    <Box style={{ paddingBottom: "20px" }}>
                        <Typography
                            style={{ color: currentTheme === "dark" ? "#ffffff" : "#202020", fontSize: "32px" }}
                            variant="contained"
                        >
                                <>
                                    Select the
                                    <br />
                                    Advertiser Account
                                </>
                        </Typography>
                    </Box>

                    {activeStep === 0 && (
                        <Box
                            style={{
                                paddingTop: "20px",
                                border: "1px",
                                borderStyle: "solid",
                                borderRadius: "20px",
                                color: "#ffffff",
                                backgroundColor: currentTheme === "dark" ? "#0B0E24" : "#fff",
                                borderColor: "#3955BF"
                            }}
                        >
                            <Box
                                style={{ height: "50vh", overflowY: "auto", overflowX: "hidden" }}
                                sx={{
                                    "&::-webkit-scrollbar": {
                                        width: "4px",
                                        height: "5px",
                                    },
                                    "&::-webkit-scrollbar-thumb": {
                                        backgroundColor: "#fff",
                                        borderRadius: "10px",
                                    },
                                    "&::-webkit-scrollbar-track": {
                                        backgroundColor: currentTheme === "dark" ? "#0B0E24" : "rgba(255,255,255,0.43)",
                                    },
                                }}
                            >
                                <Typography
                                    style={{
                                        color: currentTheme === "dark" ?  "#fff": "#0B0E24" ,
                                        fontSize: "14px",
                                        fontWeight: 500,
                                        lineHeight: "16.8px",
                                        fontFamily: "Tomorrow",
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        margin: "4px 10px",
                                    }}
                                    variant="contained"
                                >
                                    {activeStep + 1} /1
                                </Typography>
                                <Divider
                                    sx={{
                                        paddingTop: "2px",
                                        background: currentTheme === "dark" ? "#1b2440" : "rgba(255,255,255,0.68)",
                                    }}
                                />
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        aria-label="facebook-accounts"
                                        name="facebook-accounts"
                                        value={selectedAccount}
                                        onChange={handleRadioChange}
                                    >
                                        <List
                                            component="div"
                                            variant="outlined"
                                            orientation="vertical"
                                            sx={{
                                                borderRadius: 'sm',
                                                boxShadow: 'sm'
                                            }}
                                        >
                                            {Array.isArray(tikTokAdvAccount) && tikTokAdvAccount.length > 0 ? (
                                                tikTokAdvAccount.map((account, index) => (
                                                    <React.Fragment key={account.id}>
                                                        {index !== 0 && <ListDivider
                                                            sx={{
                                                                margin: '0',
                                                                width: '50vh', // Ensures the divider matches the width of the Box
                                                            }}
                                                        />}
                                                        <ListItem sx={{  backgroundColor: selectedAccount === account.id
                                                                ? (currentTheme === "dark" ? "#242633" : "#D9D9D9") : ''  , width: '100vh' }}>
                                                            <FormControlLabel
                                                                value={account.id.toString()}
                                                                control={
                                                                    <Radio
                                                                        sx={{
                                                                            color: radioColor,
                                                                            '&.Mui-checked': { color: radioColor },
                                                                            '& .MuiSvgIcon-root': {
                                                                                fontSize: '1.5rem',
                                                                            },
                                                                            '&:not(.Mui-checked)': {
                                                                                '& .MuiSvgIcon-root': {
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    width: 24,
                                                                                    height: 24,
                                                                                    borderRadius: '50%',
                                                                                    borderColor: currentTheme === 'dark' ? '#212330' : '#E5EBFF',
                                                                                    backgroundColor: currentTheme === 'dark' ? '#212330' : '#E5EBFF',
                                                                                },
                                                                            },
                                                                        }}
                                                                        checked={selectedAccount === account.id.toString()}
                                                                        checkedIcon={
                                                                            <Box
                                                                                sx={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    width: 28,
                                                                                    height: 28,
                                                                                    borderRadius: '50%',
                                                                                    border: `1px solid ${radioColor}`,
                                                                                    backgroundColor: '#3955BF',
                                                                                }}
                                                                            >
                                                                                <Box
                                                                                    sx={{
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        width: 24,
                                                                                        height: 24,
                                                                                        borderRadius: '50%',
                                                                                        position: 'relative',
                                                                                        backgroundColor: '#000',
                                                                                    }}
                                                                                >
                                                                                    <DoneRoundedIcon
                                                                                        sx={{
                                                                                            width: 20,
                                                                                            height: 20,
                                                                                            color: '#fff',
                                                                                            fontSize: '1rem',
                                                                                            backgroundColor: '#3955BF',
                                                                                            borderRadius: '50%', // Ensures the background is circular
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            justifyContent: 'center'
                                                                                        }}
                                                                                    />
                                                                                </Box>
                                                                            </Box>
                                                                        }
                                                                        icon={
                                                                            <Box
                                                                                sx={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    width: 24,
                                                                                    height: 24,
                                                                                    borderRadius: '50%',
                                                                                    border: `2px solid ${currentTheme === 'dark' ? '#212330' : '#E5EBFF'} `,
                                                                                    backgroundColor: currentTheme === 'dark' ? '#212330': '#E5EBFF',
                                                                                }}
                                                                            />
                                                                        }
                                                                    />
                                                                }
                                                                label={
                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                                                        <span style={{ color: currentTheme === "dark" ? "#fff" :"#0B0E24" , fontFamily: 'Tomorrow'  }}>{account.name}</span>
                                                                        {/*<span style={{ color: '#6F7288' , fontFamily: 'Tomorrow'}}>{account.id}</span>*/}
                                                                    </Box>
                                                                }
                                                            />
                                                        </ListItem>
                                                    </React.Fragment>
                                                ))
                                            ) : (
                                                <Typography style={{ color: '#6F7288', display: 'flex', justifyContent: 'center' }}>Loading</Typography>
                                            )}
                                        </List>
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                        </Box>
                    )}
                </Box>
                {/*<Box sx={{ padding: "16px", borderTop: `1px solid ${currentTheme === 'dark' ? '#1b2440' : 'rgba(255,255,255,0.68)'}`, backgroundColor: currentTheme === 'dark' ? '#0B0E24' : '#191d3c' }}>*/}
                <Box sx={{ padding: "16px", paddingLeft: "45px"  }}>
                    {!loading && activeStep === 0 && (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            fullWidth
                            style={{ backgroundColor: "#3955BF" }}
                        >
                            Select
                        </Button>
                    )}
                </Box>
            </SwipeableDrawer>
        </>
    );
};

const mapStateToProps = (state) => ({
    user: state.auth.auth.user,
    currentTheme: state.theme.currentTheme
});

export default connect(mapStateToProps)(TikTokPlatformDetails);
